const Field = require("../../../../../dumb/Field/E");
const formatNumFiat = require("../../../../../../utils/formatNumFiat");
const React = require("react");

const Item = ({label, fiat, code}) => fiat ? (
  <Field label={label}>
    <div className="f23 fw7 lh lts0em ws ov tov mt-5">
      {formatNumFiat(fiat)} {code}
    </div>
  </Field>
) : null

module.exports = ({availableBalance, appBalance, assetCode}) => (
  <div className="hmin162 layoutRow fxdC jcC bgF6F6F6 ph25 r9 (mv10)>1">
    {
      [
        {label: 'Available balance (all apps)', fiat: availableBalance},
        {label: 'Application balance', fiat: appBalance},
      ].map(({label, fiat}) => (
        <Item key={label} label={label} fiat={fiat} code={assetCode} />
      ))
    }
  </div>
)
